import styled, { css } from "styled-components";
import { parseCSS, startDB } from "scripts/FunctionsBundle";
import { Helmet } from "react-helmet";
import { Outlet, useNavigation } from "react-router-dom";
import GlobalNavbar from "@components/GlobalNavbar";
import GlobalFooter from "@components/GlobalFooter";
import { GS, LogIn } from "App";
import LoginScreen from "./LoginScreen";
import { useEffect, useState } from "react";

// ################################ INTERFACES & PROPS ################################
type _Base = import("@utils/ClassTypes")._Base;
// HomeScreen => Rename all instances to use
type HomeScreenProps = {} & _Base;

// ################################ RENDERING COMPONENT ################################
const _HomeScreen = (props: HomeScreenProps) => {
  const nav = useNavigation();
  const [loading, setLoading] = useState(GS.firstTime);

  // ------------------------------------------ LOG IN CHECK
  useEffect(() => {
    if (GS.firstTime) {
      GS.firstTime = false;

      (async () => {
        GS.DB = await startDB();
        await LogIn(undefined, true);
        setLoading(false);
      })();
    }
  }, []);

  return (
    <>
      <Helmet>
        <title>Inicio | RSA</title>
      </Helmet>

      <GlobalNavbar />

      {loading ? (
        <>
          <div className="spinner">Buscando sesiones guardadas...</div>
        </>
      ) : (
        <>
          {nav.state === "loading" ? (
            <div className="spinner">Cargando...</div>
          ) : nav.state === "submitting" ? (
            <div className="spinner">Enviando datos...</div>
          ) : (
            <></>
          )}
          {GS.currentUser && GS.currentUser.id ? <Outlet /> : <LoginScreen />}
        </>
      )}

      <GlobalFooter />
    </>
  );
};

// ################################ STYLES ################################
const HomeScreen = styled(_HomeScreen).attrs(
  (props: HomeScreenProps): HomeScreenProps => {
    return { ...props };
  }
)`
  ${(props) => css`
    ${parseCSS(props._style)}
  `}
`;

// ################################ EXPORTS ################################
export default HomeScreen;
